import { ApplicationAPI } from "../../api/application/application-api";
import { DocumentAPI } from "../document/document-api";

export enum GetApplicationResponseType {
  ERROR_OTP_CODE_INCORRECT = "ERROR_OTP_CODE_INCORRECT",
  ERROR_OTP_CODE_TOO_OLD = "ERROR_APPLICATION_SUBMITTED",
}

export type GetApplicationResponse = {
  error?: GetApplicationResponseType;
  application?: ApplicationAPI;
  documents?: DocumentAPI[];
}
